module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMC41IDBDNC43MTAzIDAgMCA0LjcxMDMgMCAxMC41QzAgMTYuMjg5NyA0LjcxMDMgMjEgMTAuNSAyMUMxNi4yODk3IDIxIDIxIDE2LjI4OTcgMjEgMTAuNUMyMSA0LjcxMDMgMTYuMjg5NyAwIDEwLjUgMFpNMTMuOTU3NiAxNS40NDI0TDkuNDUgMTAuOTM0N1Y0LjJIMTEuNTVWMTAuMDY1M0wxNS40NDI0IDEzLjk1NzZMMTMuOTU3NiAxNS40NDI0WiIgZmlsbD0iIzAwRDA5QyIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/svgs/time.svg
// module id = 1168
// module chunks = 1